import { FC } from 'react';

interface MetroIconProps {
    isLine: boolean;
    color: string;
}

// TODO: вместо кастомного должен использоваться компонент из магритта https://jira.hh.ru/browse/PORTFOLIO-31375
const MetroIcon: FC<MetroIconProps> = ({ isLine, color }) =>
    isLine ? (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x={9} y={4} width={6} height={16} rx={3} fill={color} />
        </svg>
    ) : (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx={12} cy={12} r={5} fill={color} />
        </svg>
    );

export default MetroIcon;
